import React from "react";
import { Navigate, Outlet, useLocation } from "react-router";
import { getValues } from "../reducers/loginReducer";
import { useSelector } from "react-redux";

export default function PrivateRoute(props) {
  const { token } = useSelector(getValues);
  const { pathname } = useLocation();

  if (token) {
    if (pathname === "/") {
      return <Navigate to="/dashboard" />;
    } else {
      return <Outlet />;
    }
  } else {
    return <Navigate to={"/login"} />;
  }
}
